import { DownloadDocumentFileType } from '../enums/downloadDocumentFileType'

const downloadDocumentFileTypeToDownloadMimeTypes: Record<DownloadDocumentFileType, string> = {
  [DownloadDocumentFileType.PDF]: 'application/pdf',
  [DownloadDocumentFileType.XML]: 'application/xml',
}

export const getDownloadDocumentMimeType = (downloadDocumentFileType: DownloadDocumentFileType): string => {
  return downloadDocumentFileTypeToDownloadMimeTypes[downloadDocumentFileType]
}
